import React, { useState } from 'react';
import { Save } from 'lucide-react';
import { useActivityLogStore } from '../../../stores/activityLogStore';
import toast from 'react-hot-toast';

export default function AdminSettings() {
  const [settings, setSettings] = useState({
    retentionDays: 30,
    enableDetailedLogs: true,
    notifyOnNewUsers: true
  });

  const handleSave = () => {
    // In a real app, this would save to a backend
    toast.success('Settings saved successfully!');
  };

  return (
    <div className="max-w-2xl space-y-6">
      <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
        <h3 className="text-lg font-medium text-gray-900 mb-4">
          System Settings
        </h3>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Log Retention (days)
            </label>
            <input
              type="number"
              value={settings.retentionDays}
              onChange={(e) => setSettings({ ...settings, retentionDays: parseInt(e.target.value) })}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
          </div>

          <div className="flex items-center">
            <input
              type="checkbox"
              checked={settings.enableDetailedLogs}
              onChange={(e) => setSettings({ ...settings, enableDetailedLogs: e.target.checked })}
              className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
            />
            <label className="ml-2 block text-sm text-gray-900">
              Enable detailed logging
            </label>
          </div>

          <div className="flex items-center">
            <input
              type="checkbox"
              checked={settings.notifyOnNewUsers}
              onChange={(e) => setSettings({ ...settings, notifyOnNewUsers: e.target.checked })}
              className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
            />
            <label className="ml-2 block text-sm text-gray-900">
              Notify on new user registrations
            </label>
          </div>

          <div className="pt-4">
            <button
              onClick={handleSave}
              className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              <Save className="h-4 w-4 mr-2" />
              Save Settings
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}